var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCityClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216,
    height: 161,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M31.161 8.064h-7.385V161h7.385V8.064Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.406 12.842a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 16.683a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 20.523a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 24.364a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 28.204a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 32.045a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 35.886a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 39.726a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.406 39.726a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 43.567a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 47.407a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 51.248a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 55.088a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 58.929a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 62.77a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 66.61a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 70.45a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.406 70.45a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 74.291a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 78.132a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 81.972a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 85.813a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.406 85.763a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 89.604a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM28.406 93.445a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 97.285a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 101.126a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 104.967a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0ZM28.406 108.807a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 112.648a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 116.488a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.406 116.488a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 120.329a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 124.169a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 128.01a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 131.85a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 135.691a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 139.532a.936.936 0 1 1-1.873-.001.936.936 0 0 1 1.873.001ZM28.406 143.372a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 147.213a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.406 147.213a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0ZM28.406 151.054a.936.936 0 1 1-1.873-.001.936.936 0 0 1 1.873.001ZM28.406 154.894a.937.937 0 1 1-1.873 0 .937.937 0 0 1 1.873 0ZM28.406 158.735a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M190.217 8.064h-7.385V161h7.385V8.064Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.465 12.842a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 16.683a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 20.523a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 24.364a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 28.204a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 32.045a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 35.886a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 39.726a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.465 39.726a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 43.567a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 47.407a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 51.248a.936.936 0 1 1-1.873 0 .936.936 0 0 1 1.873 0ZM187.465 55.088a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 58.929a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 62.77a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 66.61a.936.936 0 1 1-1.873.001.936.936 0 0 1 1.873 0ZM187.465 70.45a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.465 70.45a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 74.291a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 78.132a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 81.972a.936.936 0 1 1-1.873.001.936.936 0 0 1 1.873 0ZM187.465 85.813a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.465 85.763a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 89.604a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 93.445a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 97.285a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 101.126a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 104.967a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM187.465 108.807a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 112.648a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 116.488a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.465 116.488a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 120.329a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 124.169a.936.936 0 1 1-1.875 0 .937.937 0 0 1 1.875 0ZM187.465 128.01a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 131.85a.936.936 0 1 1-1.875 0 .936.936 0 0 1 1.875 0ZM187.465 135.691a.936.936 0 1 1-1.875 0 .937.937 0 0 1 1.875 0ZM187.465 139.532a.936.936 0 1 1-1.877 0 .936.936 0 0 1 1.877 0ZM187.465 143.372a.936.936 0 1 1-1.875 0 .936.936 0 0 1 1.875 0ZM187.465 147.213a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.465 147.213a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0ZM187.465 151.054a.936.936 0 1 1-1.877 0 .936.936 0 0 1 1.877 0ZM187.465 154.894a.936.936 0 1 1-1.875 0 .937.937 0 1 1 1.875 0ZM187.465 158.735a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDEBF3",
    d: "M1.377 18.576h213.249c.482 0 .877.391.877.876v17.023a.878.878 0 0 1-.877.876H1.377a.878.878 0 0 1-.877-.876V19.452c0-.482.392-.876.877-.876Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB65A5",
    d: "M33.343 37.072H16.087L1.057 18.855h17.256l15.03 18.217ZM70.915 37.072H53.659L38.63 18.855h17.254l15.03 18.217ZM108.487 37.072H91.233l-15.03-18.217h17.256l15.028 18.217ZM146.061 37.072h-17.256l-15.031-18.217h17.257l15.03 18.217ZM183.633 37.072h-17.256l-15.028-18.217h17.256l15.028 18.217ZM215.075 36.913a.91.91 0 0 0 .145-.186V29.82l-9.046-10.963h-17.256l15.03 18.217h10.878a.773.773 0 0 0 .249-.16v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDEBF3",
    d: "M1.377 64.884h213.249c.482 0 .877.392.877.877v17.022a.878.878 0 0 1-.877.877H1.377a.878.878 0 0 1-.877-.877V65.761c0-.482.392-.877.877-.877Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB65A5",
    d: "M33.343 83.38H16.087L1.057 65.164h17.256l15.03 18.216ZM70.915 83.38H53.659L38.63 65.164h17.254l15.03 18.216ZM108.487 83.38H91.233l-15.03-18.216h17.256l15.028 18.216ZM146.061 83.38h-17.256l-15.031-18.216h17.257l15.03 18.216ZM183.633 83.38h-17.256l-15.028-18.216h17.256l15.028 18.216ZM215.075 83.222a.91.91 0 0 0 .145-.187V76.13l-9.046-10.963h-17.256l15.03 18.217h10.878a.773.773 0 0 0 .249-.159v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDEBF3",
    d: "M1.374 111.193h213.249c.482 0 .877.392.877.876v17.023a.877.877 0 0 1-.877.876H1.377a.877.877 0 0 1-.877-.876v-17.023c0-.482.392-.873.874-.873v-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB65A5",
    d: "M33.343 129.686H16.087L1.057 111.47h17.256l15.03 18.216ZM70.915 129.686H53.659L38.63 111.47h17.254l15.03 18.216ZM108.487 129.686H91.233l-15.03-18.216h17.256l15.028 18.216ZM146.061 129.686h-17.256l-15.031-18.216h17.257l15.03 18.216ZM183.633 129.686h-17.256l-15.028-18.216h17.256l15.028 18.216ZM215.075 129.528a.894.894 0 0 0 .145-.187v-6.905l-9.046-10.963h-17.256l15.03 18.216h10.878a.756.756 0 0 0 .249-.159v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "m23.776 37.351 7.385 1.438v-1.438h-7.385ZM23.776 83.657l7.385 1.441v-1.44h-7.385ZM23.776 129.966l7.385 1.438v-1.438h-7.385ZM182.832 37.351l7.388 1.438v-1.438h-7.388ZM182.832 83.657l7.388 1.441v-1.44h-7.388ZM182.832 129.966l7.388 1.438v-1.438h-7.388Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M54.884 0h103.743a5.011 5.011 0 0 1 5.011 5.008v64.7a5.011 5.011 0 0 1-5.011 5.008H54.884a5.011 5.011 0 0 1-5.011-5.008v-64.7A5.011 5.011 0 0 1 54.884 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253673",
    d: "M157.517 2.098a3.848 3.848 0 0 1 3.846 3.843v62.414a3.847 3.847 0 0 1-3.846 3.843H55.991a3.848 3.848 0 0 1-3.846-3.843V5.94a3.848 3.848 0 0 1 3.846-3.843h101.526Zm0-.822H55.991a4.665 4.665 0 0 0-4.668 4.665v62.414a4.665 4.665 0 0 0 4.668 4.665h101.526a4.665 4.665 0 0 0 4.668-4.665V5.94a4.665 4.665 0 0 0-4.668-4.665Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253673",
    d: "M85.871 33.138c-.987-1.068-1.48-2.575-1.48-4.523v-13.39c0-1.945.493-3.454 1.48-4.522.987-1.069 2.418-1.603 4.296-1.603 1.877 0 3.308.534 4.295 1.603.987 1.068 1.48 2.577 1.48 4.522v2.635h-3.706v-2.884c0-1.542-.652-2.315-1.96-2.315-1.307 0-1.96.773-1.96 2.315V28.9c0 1.52.653 2.28 1.96 2.28 1.308 0 1.96-.76 1.96-2.28v-3.81h3.707v3.525c0 1.948-.494 3.455-1.48 4.523-.988 1.068-2.418 1.602-4.296 1.602-1.878 0-3.309-.534-4.296-1.602ZM98.29 9.456h3.919v24.928h-3.92V9.456ZM108.196 13.017h-4.098V9.456h12.116v3.561h-4.098v21.367h-3.92V13.017ZM121.845 23.772l-4.74-14.316h4.17l2.672 9.152h.072l2.672-9.152h3.813l-4.739 14.316v10.612h-3.92V23.772ZM69.352 60.532c-.987-1.069-1.48-2.575-1.48-4.523v-13.39c0-1.945.493-3.455 1.48-4.523.987-1.068 2.418-1.602 4.296-1.602 1.878 0 3.309.534 4.296 1.602.986 1.069 1.48 2.578 1.48 4.523v2.635h-3.706V42.37c0-1.543-.653-2.315-1.96-2.315-1.308 0-1.96.772-1.96 2.315v13.924c0 1.52.652 2.279 1.96 2.279 1.307 0 1.96-.759 1.96-2.28v-3.81h3.706v3.526c0 1.947-.494 3.454-1.48 4.523-.987 1.068-2.418 1.602-4.296 1.602-1.878 0-3.309-.534-4.296-1.602ZM81.773 36.85h3.92v21.367h6.45v3.56h-10.37V36.85ZM95.137 60.496c-1.023-1.093-1.533-2.635-1.533-4.63V42.761c0-1.994.51-3.536 1.533-4.63 1.022-1.092 2.494-1.637 4.418-1.637 1.925 0 3.397.545 4.419 1.638 1.023 1.093 1.533 2.635 1.533 4.63v13.104c0 1.995-.51 3.54-1.533 4.63-1.022 1.093-2.494 1.638-4.419 1.638-1.924 0-3.396-.545-4.418-1.638Zm6.45-4.38V42.512c0-1.638-.677-2.457-2.032-2.457-1.354 0-2.03.819-2.03 2.457v13.604c0 1.638.676 2.457 2.03 2.457 1.355 0 2.032-.82 2.032-2.457ZM108.928 60.515c-.973-1.08-1.461-2.63-1.461-4.646v-1.424h3.706v1.709c0 1.613.677 2.422 2.031 2.422.666 0 1.171-.195 1.513-.587.346-.391.519-1.027.519-1.906 0-1.044-.239-1.964-.713-2.761-.474-.795-1.354-1.75-2.637-2.866-1.615-1.424-2.744-2.712-3.386-3.865-.641-1.15-.962-2.452-.962-3.898 0-1.97.499-3.496 1.497-4.578.998-1.079 2.448-1.621 4.347-1.621 1.9 0 3.298.54 4.26 1.621.963 1.08 1.442 2.63 1.442 4.646v1.033h-3.706v-1.282c0-.855-.167-1.477-.499-1.871-.332-.392-.819-.586-1.461-.586-1.307 0-1.96.794-1.96 2.386 0 .901.244 1.745.732 2.528.488.784 1.373 1.734 2.656 2.85 1.64 1.424 2.769 2.717 3.386 3.88.617 1.165.926 2.53.926 4.096 0 2.041-.504 3.608-1.513 4.7-1.009 1.094-2.478 1.639-4.402 1.639-1.925 0-3.339-.54-4.312-1.622l-.003.003ZM121.401 36.85h10.691v3.56h-6.771V47h5.381v3.561h-5.381v7.657h6.771v3.56h-10.691V36.85ZM134.337 36.85h5.987c1.949 0 3.41.523 4.383 1.566.973 1.047 1.461 2.578 1.461 4.594v12.607c0 2.019-.488 3.55-1.461 4.594-.973 1.044-2.434 1.567-4.383 1.567h-5.987V36.85Zm5.915 21.367c.642 0 1.135-.19 1.481-.57.345-.378.518-.997.518-1.852V42.832c0-.854-.173-1.47-.518-1.851-.346-.381-.836-.57-1.481-.57h-1.995v17.806h1.995Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M54.884 74.713s38.888 1.657 51.856 1.657c12.978 0 51.884-1.657 51.884-1.657H54.884Z",
    opacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 23.776,
    x2: 31.161,
    y1: 84.534,
    y2: 84.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B4B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9FA1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#989A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#989A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E0E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A4A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 182.832,
    x2: 190.22,
    y1: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B4B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9FA1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#989A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#989A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E0E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A2A4A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#989A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 160.521,
    x2: 52.579,
    y1: 2.876,
    y2: 72.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h215v161H.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityClosed);
export default ForwardRef;